



// import React, { useState, useEffect } from "react";
// import HeroTextAnimation from "./HeroTextAnimation";

// // import hero1 from "../assets/hero1.jpg";
// // import hero2 from "../assets/hero2.jpg";
// // import hero3 from "../assets/hero3.jpg";
// import hero1 from "../assets/hero7.jpeg";
// //import hero2 from "../assets/hero6.jpeg";
// import hero2 from "../assets/hero9.jpeg";
// import hero3 from "../assets/hero8.jpeg";
// export default function Hero() {
//   const images = [hero1, hero2, hero3];
//   const [current, setCurrent] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrent((prev) => (prev + 1) % images.length);
//     }, 5000); // 5 seconds
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     // <section
//     //   id="home"
//     //   className="relative bg-cover bg-center bg-no-repeat transition-all duration-1000"
//     //   style={{ backgroundImage: `url(${images[current]})` }}
//     // >


//     <section
//   id="home"
//   className="relative h-[80vh] bg-cover bg-center bg-no-repeat transition-all duration-1000"
//   style={{ backgroundImage: `url(${images[current]})` }}
// >

//       {/* Overlay */}
//       <div className="absolute inset-0 bg-black bg-opacity-50"></div>

//       {/* Content */}
//       <div className="relative max-w-6xl mx-auto px-6 py-32 flex flex-col items-start justify-center">
//   <HeroTextAnimation />
//   <p className="mt-6 text-lg max-w-xl font-bold text-blue-500">
//     Reliable and accurate diagnostic services for all your pathology needs.
//   </p>
// </div>

//     </section>
//   );
// }



import React, { useState, useEffect } from "react";
import HeroTextAnimation from "./HeroTextAnimation";

import hero1 from "../assets/hero7.jpeg";
import hero2 from "../assets/hero9.jpeg";
import hero3 from "../assets/hero8.jpeg";

export default function Hero() {
  const images = [hero1, hero2, hero3];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section
      id="home"
      className="
        relative
        h-[30vh] sm:h-[70vh] md:h-[80vh]
        overflow-hidden
      "
    >
      {/* Background Image */}
      <img
        src={images[current]}
        alt="Hero background"
        className="
          absolute inset-0
          w-full h-full
          object-contain md:object-cover
          transition-opacity duration-1000
        "
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Content */}
      <div className="
        relative
        max-w-6xl mx-auto
        px-6
        h-full
        flex flex-col
        justify-center
      ">
        <HeroTextAnimation />

        <p className="mt-6 text-base sm:text-lg max-w-xl font-bold text-blue-400">
          Reliable and accurate diagnostic services for all your pathology needs.
        </p>
      </div>
    </section>
  );
}
